<template>
  <div>
    <v-menu location="bottom start">
      <template v-slot:activator="{ props }">
        <v-btn
          color="primary"
          variant="text"
          v-bind="props"
          class="text-none px-2"
          :class="{ 'justify-center': rail }"
          block
        >
          <div class="d-flex align-center w-100" :class="{ 'justify-center': rail }">
            <template v-if="rail && currentProject?.acronym">
              <div class="text-caption font-weight-bold">{{ currentProject.acronym }}</div>
            </template>
            <template v-else>
              <v-icon start :class="{ 'mr-2': !rail, 'mr-0': rail }">mdi-briefcase-outline</v-icon>
              <template v-if="!rail">
                <div class="text-truncate flex-grow-1 text-left">
                  {{ projectDisplayName }}
                </div>
                <v-icon end>mdi-chevron-down</v-icon>
              </template>
            </template>
          </div>
        </v-btn>
      </template>

      <v-list width="250">
        <v-list-subheader>Switch Project</v-list-subheader>
        
        <v-list-item
          v-for="project in projects"
          :key="project.id"
          :value="project.id"
          :active="currentProject?.id === project.id"
          @click="handleProjectSelect(project)"
          density="compact"
        >
          <template v-slot:prepend>
            <v-icon v-if="currentProject?.id === project.id" color="primary" size="small">mdi-check</v-icon>
            <div v-else style="width: 24px"></div>
          </template>
          <v-list-item-title>{{ project.name }}</v-list-item-title>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <v-list-item @click="showCreateDialog = true" density="compact" color="primary">
          <template v-slot:prepend>
            <v-icon size="small">mdi-plus</v-icon>
          </template>
          <v-list-item-title>Create New Project</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <create-project-dialog 
      v-model="showCreateDialog" 
      @created="handleProjectCreated"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CreateProjectDialog from './CreateProjectDialog.vue'

export default {
  name: 'ProjectSwitcher',
  components: {
    CreateProjectDialog
  },
  props: {
    rail: Boolean
  },
  data() {
    return {
      showCreateDialog: false
    }
  },
  computed: {
    ...mapGetters('projects', ['projects', 'currentProject']),
    projectDisplayName() {
      if (!this.currentProject) return 'Select Project'
      if (this.currentProject.acronym) return `Project ${this.currentProject.acronym}`
      return this.currentProject.name
    }
  },
  methods: {
    ...mapActions('projects', ['selectProject']),
    async handleProjectSelect(project) {
      if (this.currentProject?.id === project.id) return
      
      try {
        const acronym = project.acronym || 'def'
        await this.$router.push(`/${acronym.toLowerCase()}/dashboard`)
      } catch (error) {
        console.error('Failed to switch project:', error)
      }
    },
    handleProjectCreated() {
        // Project created and selected automatically
    }
  },
  watch: {
    currentProject: {
      handler(newVal) {
        console.log('ProjectSwitcher: currentProject changed', newVal)
      },
      deep: true,
      immediate: true
    },
    rail(newVal) {
      console.log('ProjectSwitcher: rail changed', newVal)
    }
  }
}
</script>

